<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui';

const props = defineProps<{
  name: string,
  logout:() => void,
}>();

const { partner, adminRights } = usePartner();

const items = computed<DropdownMenuItem[]>(() => {
  const menuItems: DropdownMenuItem[] = [
    {
      label: 'Your Profile',
      faIcon: ['fal', 'user'],
      to: '/profile',
      'data-cy': 'profile-menu-profile',
    },
  ];

  if (adminRights.value && partner.value?.partner.uuid) {
    menuItems.push({
      label: 'Your Team',
      faIcon: ['fal', 'user-group'],
      to: `/${partner.value.partner.uuid}/team`,
      'data-cy': 'profile-menu-team',
    });
  }

  menuItems.push({
    label: 'Logout',
    faIcon: ['fal', 'person-to-door'],
    'data-cy': 'profile-menu-logout',
    onSelect: () => {
      props.logout();
    },
  });

  return menuItems;
});
</script>

<template>
  <UDropdownMenu
    :items="items"
    :content="{ align: 'end', side: 'bottom', sideOffset: 8 }"
    :ui="{
      content: 'w-56 z-50',
      item: 'cursor-pointer',
    }"
  >
    <button
      type="button"
      aria-label="Profile menu"
      data-cy="profile-menu"
      class="inline-flex shrink-0 items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-(--ui-primary)"
    >
      <div class="flex space-x-2 items-center">
        <IconCircle
          :icon="['fal', 'user']"
          class="text-(--ui-primary) border-(--ui-primary) bg-(--ui-primary-50)"
        />
        <div class="flex items-center space-x-1 text-(--ui-primary)">
          <div class="hidden lg:block text-sm capitalize">
            {{ name }}
          </div>
          <UiFaIcon
            :icon="['fal', 'chevron-down']"
            class="ml-2 -mr-1 h-5 w-5"
          />
        </div>
      </div>
    </button>
    <template #item-leading="{ item }">
      <UiFaIcon
        v-if="item.faIcon"
        :icon="item.faIcon"
        class="size-5 shrink-0"
      />
    </template>
  </UDropdownMenu>
</template>
